export const EventID = 1;
export const CalendarID = 2;
//# sourceMappingURL=constants.js.map